import React from "react";

export const useObservable = (observable, callback) => {
  React.useEffect(() => {
    if (!observable || !callback) {
      return undefined;
    }

    observable.subscribe(callback);

    return () => {
      observable.unsubscribe(callback);
    };
  }, [observable, callback]);
};
